import { simplePegShelfDecorator, _auxAvoidCollisions_simplePeg, _recalcPosAndSize_simplePeg } from './svgDecorator-simplePegShelf';

// SlatWall currently shares free-positioning and sizing rules with hook modules.
export const slatWallShelfDecorator = _this => {
  simplePegShelfDecorator(_this);
};

export const _recalcPosAndSize_slatWall = shelf => {
  return _recalcPosAndSize_simplePeg(shelf);
};

export const _auxAvoidCollisions_slatWall = (shelfProds: any[], id: number | string, shelf): any[] => {
  return _auxAvoidCollisions_simplePeg(shelfProds, id, shelf);
};
